import {styled} from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import {FILTERS_DRAWER_WIDTH} from '../../components/FilterPanel/FilterPanelStyle'
import {Button, Typography} from '@mui/material'
import Grid from '@mui/material/Grid'

const StyledBoxDescription = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(10),
  marginLeft: `-${FILTERS_DRAWER_WIDTH}px`,
  overflow: 'auto',
  height: '85vh'
}))

const LeftPanel = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.hpWhite,
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  textAlign: 'left',
  height: '100%',
  marginLeft: theme.spacing(3),
  marginBottom: theme.spacing(3),
  width: '95%',
  marginRight: theme.spacing(3),
  fontSize: theme.typography.h6.fontSize
}))
const RightPanel = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.hpWhite,
  padding: theme.spacing(4),
  paddingBottom: theme.spacing(14),
  marginLeft: theme.spacing(3),
  minHeight: '90vh',
  marginRight: theme.spacing(3)
}))

const ClientTitle = styled(Typography)(({theme}) => ({
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.h5.fontSize,
  lineHeight: '34px', // to add in themes
  paddingTop: theme.spacing(2),
  letterSpacing: '0.315689px',
  color: theme.palette.hpBlack
}))

const ProjectDescriptionGrid = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(3)
}))

const SaveButton = styled(Button, {shouldForwardProp: (prop) => prop !== 'isAddUser'})(({theme, isAddUser}) => ({
  marginLeft: isAddUser ? '' : theme.spacing(1),
  marginTop: isAddUser ? theme.spacing(3) : '',
  padding: '8px 24px',
  minWidth: '130px',
  height: '40px',
  color: theme.palette.hpWhite,
  backgroundColor: theme.palette.hpPrimary,
  borderRadius: '4px',
  textTransform: 'capitalize',
  fontSize: theme.typography.body1.fontSize,
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryDark
  }
}))

const AddButton = styled(Button)(({theme}) => ({
  marginTop: theme.spacing(3),
  padding: '7px 16px',
  width: '158px',
  height: '30px',
  color: theme.palette.hpWhite,
  backgroundColor: theme.palette.hpPrimary
}))

const SaveAndExitButton = styled(SaveButton)(({theme}) => ({
  height: '40px',
  marginRight: theme.spacing(6)
}))

const CancelButton = styled(Button)(({theme}) => ({
  textTransform: 'capitalize',
  minWidth: '130px',
  height: '40px',
  padding: '8px 24px',
  border: `2px solid ${theme.palette.hpBaseDark}`,
  borderRadius: '4px',
  color: theme.palette.hpBaseDark,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightSemibold,
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    border: `2px solid ${theme.palette.hpBlack}`
  }
}))

const NewIcon = styled(Box)(({theme}) => ({
  width: '48px',
  height: '24px',
  backgroundColor: theme.palette.hpPrimary,
  borderRadius: theme.spacing(0.5),
  color: theme.palette.hpWhite,
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: theme.typography.h1.lineHeight,
  marginLeft: theme.spacing(1),
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center'
}))

const CenteredErrorContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '250px'
}))

const NavigationBox = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.grey[100],
  padding: `${theme.spacing(1.5)} ${theme.spacing(1.5)}`,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  paddingLeft: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  gap: theme.spacing(1)
}))

const NavigationItem = styled(Button, {shouldForwardProp: (prop) => prop !== 'selected'})(({theme, selected}) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(1.25)}`,
  textTransform: 'none',
  borderRadius: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightSemibold,
  letterSpacing: 'normal',
  backgroundColor: selected ? theme.palette.primary.main : 'transparent',
  color: selected ? theme.palette.hpWhite : theme.palette.grey[600],
  border: 'none',
  minWidth: 'auto',
  '&:hover': {
    backgroundColor: selected ? theme.palette.hpPrimaryDark : theme.palette.grey[200],
    border: 'none'
  }
}))

const StickyFooterBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.appBar,
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  marginLeft: theme.spacing(10),
  marginRight: theme.spacing(2),
  boxShadow: theme.shadows[4]
}))

export {
  LeftPanel,
  StyledBoxDescription,
  RightPanel,
  ClientTitle,
  ProjectDescriptionGrid,
  SaveButton,
  CancelButton,
  NewIcon,
  CenteredErrorContainer,
  SaveAndExitButton,
  AddButton,
  NavigationBox,
  NavigationItem,
  StickyFooterBox
}

export const StyledTogglePermissionTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.body1.fontSize,
  marginLeft: '8px',
  fontWeight: theme.typography.fontWeightRegular,
  marginBottom: '14px',
  color: theme.palette.hpBlack
}))
